import ApiError from '../../../../entities/api-error/ApiError'
import DashboardActionTypes from './DashboardActionTypes'

export interface RequestOrderGotIt {
  type: DashboardActionTypes.REQUEST_ORDER_GOT_IT;
  payload: {
    orderId:    number
    itemId?: number
  }
}

export function requestOrderGotIt({
  orderId,
  itemId,
}: RequestOrderGotIt['payload']): RequestOrderGotIt {
  return {
    type: DashboardActionTypes.REQUEST_ORDER_GOT_IT,
    payload: {
      orderId,
      itemId,
    },
  }
}

export interface RequestOrderGotItSuccess {
  type: DashboardActionTypes.REQUEST_ORDER_GOT_IT_SUCCESS;
  payload: {
    orderId:    number
  }
}

export function requestOrderGotItSuccess({
  orderId,
}: RequestOrderGotItSuccess['payload']): RequestOrderGotItSuccess {

  return {
    type: DashboardActionTypes.REQUEST_ORDER_GOT_IT_SUCCESS,
    payload: {
      orderId,
    },
  }
}

export interface RequestOrderGotItFailure {
  type: DashboardActionTypes.REQUEST_ORDER_GOT_IT_FAILURE;
  payload: {
    orderId:  number
    error:    ApiError;
  }
}

export function requestOrderGotItFailure({
  orderId,
  error,
}: RequestOrderGotItFailure['payload']): RequestOrderGotItFailure {

  return {
    type: DashboardActionTypes.REQUEST_ORDER_GOT_IT_FAILURE,
    payload: {
      orderId,
      error,
    },
  }
}
